import { Link } from 'react-router-dom';
import Layout from '../components/Layout';

export default function NotFound() {
  return (
    <Layout>
      <div className="max-w-5xl mx-auto px-4 sm:px-6 py-24 text-center">
        <p className="text-6xl font-extrabold text-brand-500 mb-4">404</p>
        <h1 className="text-2xl font-bold text-gray-900 mb-2">Page not found</h1>
        <p className="text-gray-500 mb-8">That page doesn't exist. Let's get you back on track.</p>
        <Link
          to="/"
          className="inline-flex items-center px-5 py-2.5 bg-brand-500 hover:bg-brand-600 text-white rounded-lg font-semibold text-sm transition-colors"
        >
          Go to dashboard
        </Link>
      </div>
    </Layout>
  );
}
